'use strict';

module Patersons {

  export class PortfolioService extends BaseService {

    portfolios: { [id: string]: Account }
    portfolioOrder: {
      accountId: string,
      order: number;
    }[];
    static $inject = ['$http', '$log', '$state', '$q', 'tokenService'];

    constructor($http, $log, $state, $q, tokenService) {
      super($http, $log, $state, $q, tokenService)
      this.portfolios = {};
      this.portfolioOrder = [];
    }

    private getPortfolioOrder() {
      this.portfolioOrder = []

      return this.get("/dataService/api/Portfolios/GetPortfolioOrder").then((results) => {
        this.portfolioOrder = results;
      }, (reason) => {
        console.log('No order data loaded ');
        this.log.error(reason);
      });
    }

    private getPortfolios(accounts) {
      this.portfolios = {};
      if (!Array.isArray(accounts)) {
        accounts = [accounts];
      }
      let allPromises: Array<ng.IPromise<any>> = new Array();

      for (var i = 0; i < accounts.length; i++) {
        let accountCode = accounts[i];
        var foundPortolio = this.portfolios[accountCode]
        if (foundPortolio === undefined) {
          this.log.debug("Load portfolio with accountCode: " + accountCode);
          allPromises.push(this.get("/dataService/api/Portfolios/" + accountCode)
          .then((results) => {
            this.log.info(results);
            results.summaryError = false;
            this.portfolios[accountCode] = results;
            this.log.info(this.portfolios[accountCode]);
          },
          (reason) => {
            // error handling: can't get account details
            console.log('No account data loaded '+accountCode);
            const accountPlaceholder = new Account();
            accountPlaceholder.accountId = accountCode;
            accountPlaceholder.accountName = 'Currently Unavailable';
            accountPlaceholder.summaryError = true;
            this.portfolios[accountCode] = accountPlaceholder;
            this.log.info(this.portfolios[accountCode]);
            this.log.error(reason);
          }));
        }
      }
      return Promise.all(allPromises)
    }

    getCombinedPortfolioData() {
      if (!this.tokenService.tokenManager.profile) {
        window.localStorage.setItem('$psl.redirect_uri', window.location.href);
        this.tokenService.tokenManager.redirectForToken();
        // this.state.go('dashboard')
        throw "Get Profile first";
      }

      var acccounts: Array<string> = [];
      if (this.tokenService.tokenManager.profile["account"]){
        if (this.tokenService.tokenManager.profile["account"] instanceof Array) {
          acccounts = this.tokenService.tokenManager.profile["account"];
        }
        else{
          acccounts = [this.tokenService.tokenManager.profile["account"]];
        }
      }

      var agacccounts: Array<string> = [];
      if (this.tokenService.tokenManager.profile["agaccount"]){
        if (this.tokenService.tokenManager.profile["agaccount"] instanceof Array){
          agacccounts = this.tokenService.tokenManager.profile["agaccount"];
        }
        else {
          agacccounts = [this.tokenService.tokenManager.profile["agaccount"]];
        }
      }

      acccounts = acccounts.concat(agacccounts);
      return new Promise((resolve, reject) => {
        this.getPortfolios(acccounts)
        .then((result) => {
          return this.getPortfolioOrder()
        })
        .then((result) => {
          this.log.info('All portfolios loaded' + this.portfolios);
          var accounts: Array<Account> = new Array<Account>();

          for (var key in this.portfolios) {
            this.log.info(key);
            var account = this.portfolios[key];
            account.isAuthorisedAgentAccount = (agacccounts.indexOf(account.accountId) > -1);
            accounts.push(account);
          }

          // order the accounts
          const accountsOrdered: Array<Account> = new Array<Account>();
          this.portfolioOrder.forEach((portfolioOrder) => {
            const account = accounts.filter((account) => {
              return account.accountId === portfolioOrder.accountId;
            });
            if (account && account[0]) {
              accountsOrdered.push(account[0]);
            }
          });

          // add the rest of the accounts as before
          accounts.sort((a, b) => {
            return a.accountId > b.accountId ? 1 : ((b.accountId > a.accountId) ? -1 : 0);
          }).forEach((account) => {
            if (accountsOrdered.indexOf(account) === -1) {
              accountsOrdered.push(account);
            }
          });
          resolve(accountsOrdered);
        });
      })
     
    };

    getPortfolioData() {
      if (!this.tokenService.tokenManager.profile) {
        window.localStorage.setItem('$psl.redirect_uri', window.location.href);
        this.tokenService.tokenManager.redirectForToken();
      }

      var acccounts: Array<string> = [];
      if (this.tokenService.tokenManager.profile["account"] instanceof Array) {
        acccounts = this.tokenService.tokenManager.profile["account"];
      }
      else{
        acccounts = [this.tokenService.tokenManager.profile["account"]];
      }

      return this.getPortfolios(acccounts)
        .then((result) => {
          this.log.info('All portfolios loaded' + this.portfolios);
          var accounts: Array<Account> = new Array<Account>();

          for (var key in this.portfolios) {
            this.log.info(key);
            var account = this.portfolios[key];
            account.isAuthorisedAgentAccount = false;
            accounts.push(account);
          }
          return accounts.sort((a, b) => {
            return a.accountId > b.accountId ? 1 : ((b.accountId > a.accountId) ? -1 : 0);
          });
        });
    };

    // get dashboard -> account -> header values
    getTopSectors(accountCode: string): ng.IHttpPromise<any> {
      return this.get("/dataService/api/shares/" + accountCode + "/topSectors");
    }

    getTopAssetClass(accountCode: string): ng.IHttpPromise<any> {
      return this.get("/dataService/api/shares/" + accountCode + "/topAssetClass");
    }

    getAccoladeTopSectors(accountCode: string): ng.IHttpPromise<any> {
      return this.get("/dataService/api/shares/" + accountCode + "/AccoladeTopSectors");
    }

    getAccoladeTopAssetClass(accountCode: string): ng.IHttpPromise<any> {
      return this.get("/dataService/api/shares/" + accountCode + "/AccoladeTopAssetClass");
    }

    getAccoladeHoldings(accountCode: string): ng.IHttpPromise<any> {
      return this.get("/dataService/api/shares/" + accountCode + "/AccoladeHoldings");
    }

    updateTaxFileNumber(accountCode: string, taxFileNumber: string, taxFileNumberType: string) {
      return this.post('/dataService/api/Portfolios/' + accountCode + '/SetTaxFileNumber', '{"Number": "' + taxFileNumber + '", "TaxFileNumberType": "' + taxFileNumberType + '"}');
    }

    updateBankDetails(accountCode: string, bankDetails: BankAccountDetail): ng.IHttpPromise<any> {
      return this.post('/dataService/api/Portfolios/' + accountCode + '/SetBankAccount', bankDetails);
    };

    updateAllBankDetails(accountCode: string, bankDetails: BankAccountDetail): ng.IHttpPromise<any> {
      return this.post('/dataService/api/Portfolios/' + accountCode + '/SetAllBankAccounts', bankDetails);
    };

    updatePostalAddressDetails(accountCode: string, addressDetail: Address): ng.IHttpPromise<any> {
      return this.post("/dataService/api/Portfolios/" + accountCode + "/SetPostalAddress", addressDetail);
    };

    updateResidentialAddressDetails(accountCode: string, addressDetail: Address): ng.IHttpPromise<any> {
      return this.post("/dataService/api/Portfolios/" + accountCode + "/SetResidentialAddress", addressDetail);
    };

    updateRegistrationAddressDetails(accountCode: string, addressDetail: Address): ng.IHttpPromise<any> {
      return this.post("/dataService/api/Portfolios/" + accountCode + "/SetRegistrationAddress", addressDetail);
    };

    /*updateAddressDetails(accountCode: string, addressDetail: Address): ng.IHttpPromise<any> {
        return this.post("/dataService/api/Portfolios/" + accountCode + "/SetAddress", addressDetail);
    };

    updateSensitiveAddressDetails(accountCode: string, addressDetail: Address): ng.IHttpPromise<any> {
        return this.post('/dataService/api/Portfolios/' + accountCode + '/SetSensitiveAddress', addressDetail);
    };*/

    updateEmailAddress(accountCode: string, emailAddress: EmailAddress): ng.IHttpPromise<any> {
      return this.post('/dataService/api/Portfolios/' + accountCode + '/SetEmailAddress', emailAddress);
    };
    updateSensitiveEmailAddress(accountCode: string, emailAddress: EmailAddress): ng.IHttpPromise<any> {
      return this.post('/dataService/api/Portfolios/' + accountCode + '/SetSensitiveEmailAddress', emailAddress);
    };

    updatePhoneNumbers(accountCode: string, account: Account): ng.IHttpPromise<any> {

      return this.post('/dataService/api/Portfolios/' + accountCode + '/SetPhoneNumber', account);
    };

    getInternationalShares(accountId) {
      return this.get("/dataService/api/Shares/" + accountId + '/International');
    };

    getInternationalSharesForHoldings(account: Account) {
      if (account.accountType && account.accountType.toUpperCase() === 'STANDARD') {
        return this.get("/dataService/api/Shares/" + account.accountId + '/InternationalStandard');
      } else {
        return this.get("/dataService/api/Shares/" + account.accountId + '/InternationalAccolade');
      }
    };

    getShares(accountId) {
      return this.get("/dataService/api/Shares/" + accountId);
    };


    getCombinedShares(accountId) {
      return this.get("/dataService/api/Shares/" + accountId + "/All");
    };
    getCashAccounts(accountId: string) {
      return this.get("/dataService/api/CashAccounts/" + accountId);
    };

    getHighInterestCashAccounts(accountId: string) {
      return this.get("/dataService/api/CashAccounts/" + accountId + "/HighInterest");
    };

    getTermDeposits(accountId: string) {
      return this.get("/dataService/api/TermDeposits/" + accountId);
    };

    getPortfolioValue(account: Account) {
      if (account.accountType && account.accountType.toUpperCase() === 'STANDARD') {
        return this.get("/dataService/api/StandardPortfolioValue/" + account.accountId);
      } else {
        return this.get("/dataService/api/AccoladePortfolioValue/" + account.accountId);
      }
    };

    getBackdatedPortfolioData(accountCode: string, asAt: Date): ng.IPromise<Holding[]> {
      return this.get("/dataService/api/BackdatedHolding/" + accountCode + "/" + moment(asAt).format("YYYY-MM-DD"));
    };

    getContractNotes(accountCode: string, dateFrom: Date, dateTo: Date) {
      return this.get("/dataService/api/ContractNotes/" + accountCode + "/" + moment(dateFrom).format("YYYY-MM-DD") + "/" + moment(dateTo).format("YYYY-MM-DD"));
    };

    getMarketOrders(accountCode: string) {
      return this.get("/dataService/api/MarketOrders/" + accountCode);
    };

    getOrderDepthData(securityCode: string) {
      return this.get("/financeService/OrderDepth/" + securityCode);
    };


    placeOrderRequest(details: OrderRequest): ng.IHttpPromise<any> {
      return this.post("/dataService/odata/OrderRequests", details);
    };

    getOrderRequests(): ng.IHttpPromise<any> {
      return this.get("/dataService/odata/OrderRequests/");
    };

    createCancelOrder(order: OrderRequest): ng.IHttpPromise<any> {
      return this.post("/dataService/odata/OrderRequests", order);
    };
  }
}
